import * as React from 'react';
import { Spinner } from '../../uiComponents/Spinner';
import TilmeldHoldPresenter from './TilmeldHoldPresenter';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { Tilmelding } from '../../models/Tilmelding';
import { Konkurrence } from '../../models/Konkurrence';
import { Bruger } from '../../models/Bruger';
import { Hold } from '../../models/Hold';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import { Institution } from '../../models/Institution';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import NotificationModule from '../../uiComponents/layout/Notification';
import { Laerer } from '../../models/Laerer';
import { getHoldListFromCache } from '../../infrastructure/HoldListCache';
import { Guid } from '../../infrastructure/Guid';

export interface TilmeldingRedigerProps extends RouteComponentProps<any> {
}

export interface TilmeldingRedigerState {
    tilmelding?: Tilmelding;
    konkurrence?: Konkurrence;
    bruger: Bruger;
    holdListe?: Hold[];
    validationResult: ValidationResult;
    institution: Institution;
    isSubmitting: boolean;
}

class TilmeldingRedigerContainer extends React.Component<TilmeldingRedigerProps, TilmeldingRedigerState> {
    constructor(props: TilmeldingRedigerProps) {
        super(props);

        this.state = {
            konkurrence: undefined, holdListe: undefined, bruger: getLoggedInBruger(),
            tilmelding: undefined, validationResult: new ValidationResult(), institution: getLoggedInBruger().institutioner[0],
            isSubmitting: false
        };

        this.onTilmeldingSave = this.onTilmeldingSave.bind(this);
        this.onTilmeldingChanged = this.onTilmeldingChanged.bind(this);
        this.onTilmeldingDelete = this.onTilmeldingDelete.bind(this);
        this.onInvitationAdded = this.onInvitationAdded.bind(this);
        this.onLaererRemoved = this.onLaererRemoved.bind(this);
    }

    componentDidMount() {
        const tilmeldingId = this.props.match.params.id;
        const apiCaller = createApiCaller();

        const self = this;
        apiCaller.getTilmelding(tilmeldingId).then(tilmelding => {
            tilmelding.inviteredeLaerere.forEach(i => i.uiId = Guid.newGuid());
            tilmelding.tilmeldteLaerere.forEach(i => i.uiId = Guid.newGuid());

            self.setState({ tilmelding: tilmelding, institution: tilmelding.hold.institution });

            apiCaller.getKonkurrence(tilmelding.konkurrenceId).then(konkurrence => {
                self.setState({ konkurrence: konkurrence });
            });
        });

        self.setState({ holdListe: getHoldListFromCache() });
    }

    onTilmeldingChanged(fieldName: string, value: any) {
        if (fieldName === 'institutionsnummer') {
            const valgtInst = this.state.bruger.institutioner.filter(i => i.institutionsnummer === value)[0];            
            this.setState({ institution: valgtInst });
        } else if (fieldName === 'gruppeId') {
            if (this.state.holdListe != null && this.state.tilmelding !== undefined) {
                let hold = this.state.holdListe.filter(h => h.gruppeId === value)[0];
                let changedTilmelding = this.state.tilmelding;
                changedTilmelding.hold = hold;
                this.setState({ tilmelding: changedTilmelding });
            }
        } else if (this.state.tilmelding !== undefined) {
            let changedTilmelding = this.state.tilmelding;
            changedTilmelding[fieldName] = value;
            this.setState({ tilmelding: changedTilmelding });
        }
    }

    onTilmeldingDelete() {
        var self = this;        
        if (this.state.tilmelding === undefined) {
            return;
        }
        createApiCaller().deleteTilmelding(this.state.tilmelding.id).then(x => {
            NotificationModule.showSuccess('', 'Tilmelding er slettet', true);
            self.props.history.goBack();
        });
    }

    onTilmeldingSave() {
        if (this.state.tilmelding === undefined) {
            throw new Error('tilmelding er undefined');
        }
        this.setState({isSubmitting: true});
        var self = this;

        createApiCaller().updateTilmelding(this.state.tilmelding).then((validationResult: ValidationResult) => {
            self.setState(
                {
                    validationResult: validationResult,
                    isSubmitting: false
                });
            if (validationResult.isValid) {
                NotificationModule.showSuccess('', 'Tilmelding er gemt', true);
                self.props.history.goBack();
            }
        });
    }

    onInvitationAdded() {
        const newState = this.state;
        if (newState.tilmelding === undefined) {
            return;
        }
        newState.tilmelding.inviteredeLaerere.push(new Laerer());
        this.setState(newState);
    }  
    
    onLaererRemoved(index: number) {
        const newState = this.state;
        if (newState.tilmelding === undefined) {
            return;
        }
        newState.tilmelding.tilmeldteLaerere.splice(index, 1);
        this.setState(newState);
    }

    render() {
        let header = 'Rediger tilmelding';
        if (this.state.tilmelding !== undefined && this.state.tilmelding.paaVenteliste) {
            header = 'Rediger tilmelding på venteliste';
        }

        if (this.state.konkurrence == null || this.state.holdListe == null || this.state.tilmelding == null) {
            return <Spinner />;
        } else {
            const holdListe = this.state.holdListe.filter(h => h.institution.institutionsnummer === this.state.institution.institutionsnummer);
            return (
                <PageWrapper>
                    <PageTitle title={header} />
                    <ContentWrapper>
                        <TilmeldHoldPresenter
                            konkurrence={this.state.konkurrence}
                            primaerLaerer={this.state.bruger}
                            tilmelding={this.state.tilmelding}
                            holdListe={holdListe}
                            validationResult={this.state.validationResult}
                            onTilmeldingSave={this.onTilmeldingSave}
                            onTilmeldingChanged={this.onTilmeldingChanged}
                            onTilmeldingDelete={this.onTilmeldingDelete}
                            opretRediger='rediger'
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}
                            isSubmitting={this.state.isSubmitting}
                            onInvitationAdded={this.onInvitationAdded}
                            onLaererRemoved={this.onLaererRemoved}
                            valgtInstitution={this.state.institution}
                            venteliste={this.state.tilmelding.paaVenteliste}
                        />
                    </ContentWrapper>
                </PageWrapper>
            );
        }
    }
}

export default TilmeldingRedigerContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmelding/TilmeldingRedigerContainer.tsx